<template>
  <div id="page-error-report-settings">
    
    <memlist-card title="" class="mb-2 mx-auto" hide-footer>
      <div>
        <form class="mt-8" @submit="saveData">
          
          <h4 class="mt-8 mb-4">{{ $t('COMPANY_SETTINGS.INCLUDE_ERRORS') }}</h4>
          
          <memlist-checkbox
            class="mt-4"
            v-if="local_settings && local_item.sid === local_item.company_id"
            :text="$t('COMPANY_SETTINGS.NO_ACTIVE_PERIOD')"
            v-model="local_settings.show_warnings.NO_ACTIVE_PERIOD"
          />

          <memlist-checkbox
            class="mt-4"
            v-if="local_settings && local_item.sid === local_item.company_id"
            :text="$t('COMPANY_SETTINGS.NO_ACTIVE_ITEMS_FOR_PERIOD')"
            v-model="local_settings.show_warnings.NO_ACTIVE_ITEMS_FOR_PERIOD"
          />

          <memlist-checkbox
            class="mt-4"
            v-if="local_settings"
            :text="$t('COMPANY_SETTINGS.NO_ACTIVE_ITEMS_FOR_COMPANY')"
            v-model="local_settings.show_warnings.NO_ACTIVE_ITEMS_FOR_COMPANY"
          />

          <memlist-checkbox
            class="mt-4"
            v-if="local_settings && local_item.sid === local_item.company_id"
            :text="$t('COMPANY_SETTINGS.NO_MEMBER_MEMBERSHIPS')"
            v-model="local_settings.show_warnings.NO_MEMBER_MEMBERSHIPS"
          />

          <memlist-checkbox
            class="mt-4"
            v-if="local_settings && local_item.sid === local_item.company_id"
            :text="$t('COMPANY_SETTINGS.MEMBER_INACTIVE_AUTORENEW')"
            v-model="local_settings.show_warnings.MEMBER_INACTIVE_AUTORENEW"
          />

          <memlist-checkbox
            class="mt-4"
            v-if="local_settings && local_item.sid === local_item.company_id"
            :text="$t('COMPANY_SETTINGS.MEMBER_INVALID_EMAIL')"
            v-model="local_settings.show_warnings.MEMBER_INVALID_EMAIL"
          />

          <memlist-checkbox
            class="mt-4"
            v-if="local_settings && local_item.sid === local_item.company_id"
            :text="$t('COMPANY_SETTINGS.MEMBER_INVALID_PERSONNR')"
            v-model="local_settings.show_warnings.MEMBER_INVALID_PERSONNR"
          />

          <memlist-checkbox
            class="mt-4"
            v-if="local_settings && local_item.sid === local_item.company_id"
            :text="$t('COMPANY_SETTINGS.MEMBER_INVALID_DOB')"
            v-model="local_settings.show_warnings.MEMBER_INVALID_DOB"
          />

          <memlist-checkbox
            class="mt-4"
            v-if="local_settings && local_item.sid === local_item.company_id"
            :text="$t('COMPANY_SETTINGS.MEMBER_INVALID_RDT')"
            v-model="local_settings.show_warnings.MEMBER_INVALID_RDT"
          />

          <RightSaveButton
            class="mt-4"
            ref="save-button"
            :text="$t('COMMON.SAVE')"
            @clicked="saveData()"
          />

        </form>
      </div>
    </memlist-card>
  </div>
</template>


<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import RightSaveButton from '@/view/components/buttons/RightSaveButton.vue';

export default {
  name: 'ErrorReportSettings',
  components: {
    RightSaveButton
  },
  mixins: [ toasts ],
  props: ['company_id', 'company', 'extras'],
  emits: ['saved', 'change'],
  computed: {
    creating() {
      if (this.local_item && this.local_item.company_id) {
        return false;
      }

      return true;
    },
    ...mapGetters(['currentPeriodId', 'currentCompanyId', 'companies']),
    
  },
  mounted() {


  },
  data() {
    return {
      local_settings: {
        show_warnings: {}
      },
      local_item: {},

    };
  },
  watch: {
    companies: {
      deep: true,
      handler(val) {

      }
    },
    company_id(newValue, oldValue) {
      
    },
    


    /// watch company deep
    company: {
      deep: true,
      handler(val) {

        if (this.company) {
          this.local_item = { ...this.company }
        }

        if (this.company.company_settings) {
          this.local_item.gdpr_contact_email = this.company.company_settings.gdpr_contact_email;
          this.local_item.gdpr_contact_name = this.company.company_settings.gdpr_contact_name;

          this.local_settings = this.company.company_settings;
        }

        if (!this.local_settings.show_warnings) {
          this.local_settings.show_warnings = {};
        }

      },
      immediate: true
    },


  },
  methods: {

    change_data() {
      this.$emit('change', this.local_item);
    },

    async saveData() {
      const loader = this.$loading.show();

      try {
        const res = await axios.put(`/company/${this.local_item.company_id}`, { show_warnings: this.local_settings.show_warnings } );

        if (res.status === 200) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('PAGES.SETTINGS.UPDATED'));

        } else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.SETTINGS.UNABLE_UPDATE'));
        }

        loader && loader.hide();
        this.$refs['save-button'].stop();
      }
      catch (err) {
        if (err.response) {
          console.log(err.response.status);

          if (err.response.status === 409) {
            this.toastr(
              'danger',
              this.$t('COMMON.ERROR'),
              this.$t('COMPANY.CNUM_ALREADY_EXISTS', { cnum: this.local_item.cnum})
            );

            loader && loader.hide();
            this.$refs['save-button'].stop();

            return;
          }
        }

        console.error('catched error', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.SETTINGS.UNABLE_UPDATE'));
      }

      this.$refs['save-button'].stop();
    },

  }
};
</script>
